import { fb } from '../../../lib/form';
export function getCategoryListModel(data, defaultCategories, clubCategories, decorationTypes) { 
    var categoryOptions = [{name : 'All Categories', value : ''}];
    if(clubCategories && clubCategories.length > 0){
      clubCategories.forEach(el => {
        categoryOptions.push({name : el.categoryName, value : el.clubCategoryId});
      });
    }

    var decorationOptions = [{name : 'All Decoration Types', value : ''}];
    if(decorationTypes && decorationTypes.length > 0){
      decorationTypes.forEach(el => {
        decorationOptions.push({name : el.categoryName, value : el.clubCategoryId});
      });
    }

    const controls = {
      categoryList: ['', [], {
        label: 'CATEGORY',
        type: 'select',
        options : categoryOptions
      }]
    };

    if (decorationTypes && decorationTypes.length > 0) {
      controls.decorationTypeList = ['', [], {
        label: 'DECORATION TYPE',
        type: 'select',
        options : decorationOptions
      }];
    }

    const model = fb.group(controls); 
    return model;
}